import type { TenantConfig } from '@/interfaces/tenant'
import { useAuthStore } from '@/stores/auth'
import axios from 'axios'
import { inject } from 'vue'

let isLoading: (val: boolean) => void
export const setIsLoading = (fn: (val: boolean) => void) => (isLoading = fn)

function useTenantApi() {
  const tenantConfig = inject('tenantConfig') as TenantConfig
  const baseUrl = tenantConfig?.apiBaseUrl || import.meta.env.VITE_MJSB2B_BACKEND_URL

  const api = axios.create({
    baseURL: baseUrl,
    // timeout: 60000,
  })

  api.interceptors.request.use(
    (config) => {
      isLoading?.(true)

      const auth = useAuthStore()
      const bearerToken = auth.token || auth.pendingToken
      if (bearerToken) {
        config.headers.Authorization = `Bearer ${bearerToken}`
      }

      return config
    },
    (err) => {
      isLoading?.(false)
      return Promise.reject(err)
    },
  )

  api.interceptors.response.use(
    (res) => {
      isLoading?.(false)
      return res
    },
    (err) => {
      isLoading?.(false)
      return Promise.reject(err)
    },
  )

  return api
}

export default useTenantApi
